module.exports = __webpack_public_path__ + "baafe6ae7c13517c2846f77248353428.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg61.jpeg
// module id = 74
// module chunks = 0